import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=17a61814&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"
import style0 from "./alerts.vue?vue&type=style&index=0&id=17a61814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a61814",
  null
  
)

export default component.exports